import type { Type } from '@angular/core';
import { ContentChild, Directive, inject } from '@angular/core';

import { TemplateResolver } from '../../utils/template-resolver';
import { HeaderDefaultComponent } from './header-default.component';
import { Select2HeaderDirective } from './header.directive';

@Directive({
  standalone: true,
  selector: 'rt-select2-header-resolver',
})
export class HeaderResolverDirective extends TemplateResolver<
  Select2HeaderDirective,
  { optional: true }
> {
  @ContentChild(Select2HeaderDirective)
  public override contentDirective?: Select2HeaderDirective;
  public override injectedComponent = <Type<HeaderDefaultComponent>>(
    (<unknown>inject(HeaderDefaultComponent, { optional: true }))
  );
  public override defaultComponent = null;
}
